import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

const ease = [0.16, 1, 0.3, 1];

const ITEMS = [
  {
    title: "Smartphone-Reparaturen",
    detail: "Displays, Akkus, Board-Repair – Handwerk mit Elektronik.",
  },
  {
    title: "KI & Automatisierung",
    detail: "Modelle, Prompts und Workflows für den echten Alltag.",
  },
  {
    title: "Eigene Website",
    detail: "Diese Seite hier – kleine Details, große Freude.",
  },
  {
    title: "React & moderne Webtechnologien",
    detail: "Framework-Hopping und was am Ende hängen bleibt.",
  },
  {
    title: "Cloud & Hosting",
    detail: "Deployments, Domains und alles rund um Infrastruktur.",
  },
  {
    title: "Bücher & lebenslanges Lernen",
    detail: "Non-Fiction, Tech-Podcasts, kein Ende in Sicht.",
  },
];

/**
 * Now – "Currently working on / exploring".
 */
export default function Now() {
  return (
    <section
      id="now"
      data-testid="now-section"
      className="relative px-6 py-24 sm:px-10 md:px-16 lg:px-24"
    >
      <div className="mx-auto w-full max-w-5xl">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease }}
          className="mb-10 flex items-center justify-between gap-6"
        >
          <p className="font-mono-label text-xs text-zinc-500">
            <span className="mr-3 text-[#FF4500]">02</span> Currently
          </p>
          <span className="inline-flex items-center gap-2 rounded-full border border-white/[0.08] bg-white/[0.02] px-3 py-1.5 text-[10px] font-medium text-zinc-500">
            <Sparkles size={11} className="text-[#CCFF00]" />
            <span className="font-mono-label">Aktiv</span>
          </span>
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease, delay: 0.05 }}
          className="font-display mb-14 max-w-3xl text-3xl font-bold leading-tight tracking-tight text-[#FAFAFA] sm:text-4xl md:text-5xl"
          data-testid="now-headline"
        >
          Aktuell beschäftige ich mich mit
        </motion.h2>

        <motion.ul
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          variants={{
            hidden: {},
            show: { transition: { staggerChildren: 0.07 } },
          }}
          className="grid grid-cols-1 gap-x-10 gap-y-6 sm:grid-cols-2"
          data-testid="now-list"
        >
          {ITEMS.map((it, i) => (
            <motion.li
              key={it.title}
              variants={{
                hidden: { opacity: 0, y: 16 },
                show: {
                  opacity: 1,
                  y: 0,
                  transition: { duration: 0.55, ease },
                },
              }}
              className="group flex items-start gap-4 border-t border-white/[0.06] pt-6"
            >
              <span className="font-mono-label mt-1 text-[10px] text-zinc-600">
                0{i + 1}
              </span>
              <div className="min-w-0">
                <p className="font-display text-lg font-semibold tracking-tight text-[#FAFAFA] transition-colors duration-300 group-hover:text-[#FF4500]">
                  {it.title}
                </p>
                <p className="mt-1 text-sm leading-relaxed text-zinc-500">
                  {it.detail}
                </p>
              </div>
            </motion.li>
          ))}
        </motion.ul>
      </div>
    </section>
  );
}
